import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

interface EventInfoProps {
  data: DataItem[];
}
interface DataItem {
  label: string;
  value: number | string | undefined;
  format?: (value: number | string | undefined) => string;
}
const EventInfo: React.FC<EventInfoProps> = ({ data }) => {
  const { t } = useTranslation(['associations']);
  const defaultFormat = (value: number | string | undefined) =>
    value !== undefined ? value.toString() : '-';
  return (
    <div className="grid grid-cols-2 md:flex md:justify-between gap-4 md:gap-0 py-4 bg-white rounded-lg">
      {data.map((item, index) => (
        <div
          key={`event-info-${item.label}`}
          className={classnames(
            'text-left md:border-l border-[#EBEBEB] md:first:border-none',
            {
              'pl-0': index === 0,
              'md:pl-4': index !== 0
            }
          )}
        >
          <div className="text-gray-500 text-sm md:text-base">{t(item.label)}</div>
          <div className="text-lg md:text-xl font-bold">
            {item.value !== undefined && item.format
              ? item.format(item.value)
              : defaultFormat(item.value)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default EventInfo;
